import React, { useState, useEffect } from 'react';
import { getCurrentUser, getUserProfile, logoutUser } from '../utils/userDataManager';
import './UserSwitcher.css';

function UserSwitcher() {
  const [profile, setProfile] = useState(null);
  const currentUser = getCurrentUser();

  useEffect(() => {
    async function loadProfile() {
      const userProfile = await getUserProfile();
      setProfile(userProfile);
    }
    if (currentUser) {
      loadProfile();
    }
  }, [currentUser]);

  const handleSwitchUser = () => {
    logoutUser();
  };

  if (!currentUser || !profile) return null;

  const displayName = profile.display_name || profile.displayName || currentUser;

  return (
    <div className="user-switcher">
      <div className="user-badge">
        <span className="user-initial">{displayName.charAt(0).toUpperCase()}</span>
        <span className="user-display-name">{displayName}</span>
      </div>
      <button className="switch-user-btn" onClick={handleSwitchUser} title="Switch User">
        ⇄
      </button>
    </div>
  );
}

export default UserSwitcher;
